import "./styles.less";

import { FC } from "react";
import { encodeHashUrl } from "../../Utils/Functions";
import { useRouter } from "next/router";
import { useWindowSize } from "shared-components/GlobalHooks/useWindowSize";

export interface LinkProps {
	pathname?: string;
	data?: any;
	routeVars?: any;
	as?: string;
	avoidRouter?: boolean;
	callback?: () => void | null;
	isExternal?: boolean;
	isBlank?: boolean;
	children?:any;
	isActive?: boolean;
}

export const PageLink: FC<LinkProps> = ({
	pathname,
	data = {},
	routeVars,
	as,
	children,
	avoidRouter,
	callback = null,
	isExternal = false,
	isBlank = false,
	isActive = true
}) => {
	const router = useRouter();
    const screen = useWindowSize();
    const isDesktop = screen.lg || screen.xl;

	const onClick = e => {
		const isOverlayClick = (e.target.classList.contains(".ant-modal-wrap") || e.target.closest(".ant-modal-wrap")) || (e.target.classList.contains(".modal-backdrop") || e.target.closest(".modal-backdrop"));

		if (e.ctrlKey || e.metaKey) return false;

		if (!isActive) {
			e.preventDefault();
			
			if (typeof callback == "function") callback();
			return null;
		}

		if (!avoidRouter && !isExternal && !isOverlayClick) {
			e.preventDefault();

			if (isBlank) {
				return window.open(`/${as}`, "_blank");
			}

			router.push(
				{
					pathname: pathname,
					query: { hashed: encodeHashUrl(data), ...routeVars },
				},
				"/" + as
			);
		}

		if (typeof callback == "function") callback();

		if (isExternal) {
			e.preventDefault();
			window.open(
				as,
				"_blank",
				"location=yes,height=670,width=620,scrollbars=yes,status=yes"
			);
		}
	};

	return (
		<a
			className="containerLink"
			onClick={onClick}
			href={isExternal ? "#" : "/" + as}
			target={isDesktop ? "_blank" : "_self"}
			title={data.title}
		>
			{children}
		</a>
	);
};
